import React from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Thanks from "../pages/thanks/page";
import AdminLoginPage from "../pages/admin/login/page";
import AdminRegisterPage from "../pages/admin/register/page";
import AdminWorkersPage from "../pages/admin/workers/page";
import AdminReviewsPage from "../pages/admin/reviews/page";
import WorkerEvaluationPage from "../pages/admin/workers/[id]/page";
import WorkerOfferPage from "../pages/admin/workers/[id]/offer/page";
import MockWorkersPage from "../pages/mock-workers/page";
import MockWorkerDetailPage from "../pages/mock-workers/[id]/page";
import MockWorkerOfferPage from "../pages/mock-workers/[id]/offer/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import ReviewPage from "../pages/review/page";
import ChatPage from "../pages/chat/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: React.createElement(Home),
  },
  {
    // あおいに聞く（ワーカーさん向け）
    path: "/chat",
    element: React.createElement(ChatPage),
  },
  {
    // 帰り道のアンケート（ワーカーさん → 園）
    path: "/review",
    element: React.createElement(ReviewPage),
  },
  {
    path: "/thanks",
    element: React.createElement(Thanks),
  },
  {
    path: "/privacy-policy",
    element: React.createElement(PrivacyPolicy),
  },
  {
    path: "/admin/login",
    element: React.createElement(AdminLoginPage),
  },
  {
    path: "/admin/register",
    element: React.createElement(AdminRegisterPage),
  },
  {
    path: "/admin/workers",
    element: React.createElement(AdminWorkersPage),
  },
  {
    path: "/admin/reviews",
    element: React.createElement(AdminReviewsPage),
  },
  {
    path: "/admin/workers/:id",
    element: React.createElement(WorkerEvaluationPage),
  },
  {
    path: "/admin/workers/:id/offer",
    element: React.createElement(WorkerOfferPage),
  },
  {
    path: "/mock-workers",
    element: React.createElement(MockWorkersPage),
  },
  {
    path: "/mock-workers/:id",
    element: React.createElement(MockWorkerDetailPage),
  },
  {
    path: "/mock-workers/:id/offer",
    element: React.createElement(MockWorkerOfferPage),
  },
  {
    path: "*",
    element: React.createElement(NotFound),
  },
];

export default routes;